import { render, staticRenderFns } from "./MusicBook.vue?vue&type=template&id=410c0670&"
import script from "./MusicBook.vue?vue&type=script&lang=js&"
export * from "./MusicBook.vue?vue&type=script&lang=js&"
import style0 from "./MusicBook.vue?vue&type=style&index=0&id=410c0670&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports